import { BaseUnits } from "uom";
import { Inch, Foot, Millimeter, CentiMeter, Decimeter } from "./length";
import { Squared } from "../unit-squared";
/** The metric unit for area quantities ( <code>m²</code> ). */
export var SquareMeter = Squared("SquareMeter", BaseUnits.Meter);
/// Area
export var SquareInch = Squared("SquareInch", Inch);
export var SquareFeet = Squared("SquareFeet", Foot);
export var SquareMillimeter = Squared("SquareMillimeter", Millimeter);
export var SquareCentimeter = Squared("SquareCentimeter", CentiMeter);
export var SquareDecimeter = Squared("SquareDecimeter", Decimeter);
//# sourceMappingURL=area.js.map